export const menuItems = [
    {
        id: 99,
        label: "menuitems.overview.text",
        svg: "Statistic",
        subItems: [
            {
                id: 99,
                label: "menuitems.overviews.list.performance_dashboard",
                link: "/dashboard",
                permission: "dashboards.view"
            },
            {
                id: 991,
                label: "menuitems.overviews.list.financial_dashboard",
                link: "/projections",
                permission: "dashboards.view"
            }
        ]
    },
    {
        id: 100,
        label: "menuitems.transactions.text",
        isTitle: true
    },
    {
        id: 101,
        label: "menuitems.tickets.text",
        svg: "Folder",
        link: "/tickets",
        permission: "tickets.view",
    },
    {
        id: 102,
        label: "menuitems.purchases.text",
        svg: "Buy",
        subItems: [
            {
                id: 1021,
                label: "menuitems.purchase_orders.text",
                link: "/purchase_orders",
                permission: "purchase_orders.view"
            },
            // {
            //     id: 1022,
            //     label: "menuitems.balancings.text",
            //     link: "/balancings"
            // }
        ]
    },
    {
        id: 103,
        label: "menuitems.payments.text",
        svg: "Wallet",
        subItems: [
            {
                id: 1031,
                label: "menuitems.odoo_account_payments.text",
                link: "/odoo_account_payments",
                permission: "odoo_purchase_invoices.view",
            },
            // {
            //     id: 1032,
            //     label: "menuitems.purchase_payments.text",
            //     link: "/purchase_payments",
            //     permission: "purchase_invoices.view"
            // },
            // {
            //     id: 1033,
            //     label: "menuitems.balancing_payments.text",
            //     link: "/balancing_payments"
            // }
        ]
    },
    {
        id: 104,
        label: "menuitems.trips.text",
        svg: "Paper",
        link: "/trips",
        permission: "trips.view",
    },
    //{
    //  id: 105,
    //  label: "menuitems.delivery_orders.text",
    //  svg: "Ticket-Star",
    //  link: "/delivery_orders"
    //},
    {
        id: 107,
        label: "menuitems.unloads.text",
        svg: "Paper-Upload",
        link: "/unloads",
        permission: "sale_order.view",
    },
    {
        id: 108,
        label: "menuitems.sale_notes.text",
        svg: "Document",
        link: "/sale_notes",
        permission: "sale_reports.view"
    },
    {
        id: 109,
        label: "menuitems.sale_invoices.text",
        svg: "Ticket",
        subItems: [
            {
                id: 1091,
                label: "menuitems.odoo_sale_invoices.text",
                link: "/odoo_sale_invoices",
                permission: "odoo_sale_invoices.view",
            },
            // {
            //     id: 1092,
            //     label: "menuitems.sale_invoices.text",
            //     link: "/sale_invoices",
            //     permission: "sale_invoices.view",
            // },
        ]
    },
    {
        id: 200,
        label: "menuitems.partner_facilities.text",
        isTitle: true
    },
    // {
    //     id: 201,
    //     label: "menuitems.services.text",
    //     svg: "Service",
    //     link: "/services",
    //     permission: "beta_services.view"
    // },
    {
        id: 202,
        label: "menuitems.customers.text",
        svg: "User3",
        link: "/customers",
        permission: "customers.view"
    },
    {
        id: 300,
        label: "menuitems.operationals.text",
        isTitle: true,
    },
    {
        id: 301,
        label: "menuitems.deliveries.text",
        svg: "Vehicle",
        subItems: [
            {
                id: 302,
                label: "menuitems.vehicles.text",
                link: "/vehicles",
                permission: "vehicles.view"
            },
            {
                id: 303,
                label: "menuitems.drivers.text",
                link: "/drivers",
                permission: "drivers.view"
            },
        ]
    },
    {
        id: 304,
        label: "menuitems.manufactures.text",
        svg: "User3",
        link: "/manufactures",
        permission: "hatcheries.view"
    },
    {
        id: 305,
        label: "menuitems.feeds.text",
        svg: "User3",
        link: "/feeds",
        permission: "feed_products.view"
    },
    {
        id: 401,
        label: "menuitems.credentials.text",
        isTitle: true
    },
    {
        id: 402,
        label: "menuitems.jala_users.text",
        svg: "User2",
        link: "/users",
        permission: 'users.view'
    },


    // {
    //     id: 300,
    //     label: "menuitems.master_data.text",
    //     isTitle: true
    // },
    // {
    //     id: 301,
    //     label: "menuitems.companies.text",
    //     icon: "bx-buildings",
    //     link: "/companies"
    // },
    // {
    //     id: 302,
    //     label: "menuitems.customers.text",
    //     icon: "bx-group",
    //     link: "/customers"
    // },
    // {
    //     id: 303,
    //     label: "menuitems.vehicles.text",
    //     icon: "bxs-truck",
    //     link: "/vehicles"
    // },
    // {
    //     id: 304,
    //     label: "menuitems.drivers.text",
    //     icon: "bx-buoy",
    //     link: "/drivers"
    // },
    // {
    //     id: 305,
    //     label: "menuitems.trips.text",
    //     icon: "bxs-direction-right",
    //     link: "/trips"
    // },
    // {
    //     id: 900,
    //     label: "menuitems.jala_data.text",
    //     isTitle: true
    // },
    // {
    //     id: 901,
    //     label: "menuitems.jala_farms.text",
    //     icon: "bx-grid",
    //     link: "/jala_farms"
    // },
    // {
    //     id: 902,
    //     label: "menuitems.jala_ponds.text",
    //     icon: "bx-square",
    //     link: "/jala_ponds"
    // },
    // {
    //     id: 903,
    //     label: "menuitems.jala_cycles.text",
    //     icon: "bx-rotate-left",
    //     link: "/jala_cycles"
    // },
    // {
    //     id: 904,
    //     label: "menuitems.jala_harvests.text",
    //     icon: "bx-cube",
    //     link: "/jala_harvests"
    // },
];
